// extracted by mini-css-extract-plugin
module.exports = {"PartnersWrap":"Partners_PartnersWrap__LiqNw","PartnersImgWrap":"Partners_PartnersImgWrap__3J0v1","PartnersImg":"Partners_PartnersImg__2CgOM"};